







































import { Component, Inject, Vue } from "vue-property-decorator";
import { IFilter } from "@/models/tables";
import {
  ITicketsProvider,
  ITicketsProviderMethods
} from "@/models/providers/tickets";
import { FilterTypes } from "@/data/table";
@Component({
  components: {
    "select-filter": () =>
      import("@/components/app/global/dataFilters/selectFilter.vue"),
    "select-checkbox-filter": () =>
      import("@/components/app/global/dataFilters/selectCheckboxFilter.vue"),
    "select-radio-group-filter": () =>
      import("@/components/app/global/dataFilters/selectRadioGroupFilter.vue"),
    "string-filter": () =>
      import("@/components/app/global/dataFilters/stringFilter.vue")
  }
})
export default class InboxFilterControls extends Vue {
  // Inject
  @Inject({ from: "ticketsProvider" })
  public readonly $ticketsProvider!: () => ITicketsProvider;
  @Inject({ from: "ticketsProviderMethods" })
  public readonly $ticketsMethods!: ITicketsProviderMethods;

  // Computed

  public get ticketsProvider() {
    return this.$ticketsProvider();
  }

  public get availableFilters() {
    return this.ticketsProvider.availableFilters || [];
  }

  public get defaultFilters() {
    return this.ticketsProvider.defaultFilters || [];
  }

  public get activeFilters() {
    return this.ticketsProvider.activeFilters || [];
  }

  public get computedFilters() {
    const _ = this.$_;
    return _.map(this.availableFilters, filter => {
      const defaultKey = filter.key;
      const defaultFilter = _.find(this.defaultFilters, ["key", defaultKey]);
      const defaultValue = _.get(defaultFilter, "value", filter.value);

      let value, isDefault;

      /** If SELECT_RADIO_GROUP enforce computed value format of {key}::{value}.
       * This allows a single group of options to filter across different
       * properties (eg `users.id` and `lead_user.id`). */

      if (filter.type === FilterTypes.SELECT_RADIO_GROUP) {
        value = `${filter.key}::${filter.value}`;
        _.each(filter.options, option => {
          const key = _.get(option, "key") || filter.key;
          const activeMatch = _.find(this.activeFilters, ["key", key]);
          if (activeMatch) {
            value = `${key}::${_.get(activeMatch, "value", filter.value)}`;
            return false;
          }
        });
        isDefault = _.isEqual(value, `${defaultKey}::${defaultValue}`);
      } else {
        const activeMatch = _.find(this.activeFilters, ["key", filter.key]);
        value = _.get(activeMatch, "value", filter.value);
        isDefault = _.isEqual(value, defaultValue);
      }

      let key = filter.key;
      if (_.isString(value)) {
        const matches = value.match(/^(.+)?(?:::)(.+)?/);
        if (matches?.length) key = matches[1] || filter.key;
      }

      return {
        ...filter,
        defaultKey,
        defaultValue,
        isDefault,
        key,
        value
      };
    });
  }

  public get orderedFilters() {
    const filtersKeyed = this.$_.map(this.availableFilters, "key");
    return this.$_.sortBy(this.computedFilters, (filter: IFilter) =>
      filtersKeyed.indexOf(filter.defaultKey || filter.key)
    );
  }

  // Methods
  public applyFilter(index: number, value: any, key?: string) {
    const filters = this.$_.map(
      this.orderedFilters as IFilter[],
      (filter, fI) => {
        const filterKey = (index === fI && key) || filter.key;
        let filterValue = index === fI ? value : filter.value;
        if (filter.type === FilterTypes.SELECT_RADIO_GROUP)
          filterValue = this.$_.last(filterValue.split("::")) as any;
        return { ...filter, key: filterKey, value: filterValue };
      }
    );
    this.$ticketsMethods.applyFilters(
      filters.filter((filter: IFilter) => {
        return !this.$_.isEmpty(filter.value);
      })
    );
  }
}
